import React from "react";
import { useSelector } from "react-redux";
import { getFormValues } from "redux-form";

import { AI_GENERATE_VERSIONS_FORM } from "./constants";
import VariationPreview from "./VariationPreview";

export default function SelectedVersions(props){
	const { creatives=[]} = useSelector(state => state.versionGeneration);
	const { selectedVariations = {} } = useSelector(getFormValues(AI_GENERATE_VERSIONS_FORM));

	const groups = Object.entries(selectedVariations).map(([creativeId, { variations }]) => {
		if(!variations.length){ return null; }

		const creative = creatives.find(creative => `${creative.id}` === `${creativeId}`);

		return (
			<div
				key={creativeId}
				className="preview-group"
			>
				<h2>{creative?.name}</h2>
				<div className="preview-options">
					{variations.map((value, index) => {
						const key = `cart_${creativeId}_${index}`
							, ftUtilsId = `place_${creativeId}_${index}`
							;

						return (
							<VariationPreview
								key={key}
								ftUtilsId={ftUtilsId}
								creativeId={creativeId}
								variables={value}
							/>
						);
					})}
				</div>
			</div>
		);
	});

	return (
		<div className="previews">
			{groups}
		</div>
	);
}

SelectedVersions.displayName = "SelectedVersions";
